module.exports = __webpack_public_path__ + "static/products-paas-for-business-central-737ae4b71f3560580ae52914d13e7baf.png";